/**
 * Footer Chunk
 *
 * フッターで使用するLitコンポーネントをバンドルするチャンク。
 * このファイルは遅延読み込みされます。
 */

import { SELECTORS } from '../constants/selectors';

// #2960: フッターアコーディオン
export { KdFooterAccordion } from '../components/footer/kd-footer-accordion';

// #2960: トップにもどるボタン（インライン onclick 回避）
document.querySelector(SELECTORS.FOOTER.SCROLL_TOP)?.addEventListener('click', () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
});
